import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlagIcon } from '~/components/flag-icon/FlagIcon';
import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';

import * as S from './CountryCard.styles';

export interface CountryCardProps {
  code: string;
  rank?: number;
  onClick?: () => void;
}

export const CountryCard = ({ code, rank, onClick }: CountryCardProps) => {
  const { t } = useTranslation(['countries']);

  return (
    <S.Root data-testid="country-card" onClick={onClick}>
      <S.IconsWrapper>
        <FlagIcon countryCode={code} customSize={32} variant="circular" />
        {rank && (
          <TopRankIcon
            rank={rank}
            iconSize={24}
            wrapperSize={24}
            rankFontSize={10}
            rankTopPosition="20%"
          />
        )}
      </S.IconsWrapper>
      <S.FlexColumn>
        <S.TitleLabel data-testid={`${code}-label`}>
          {t(`countries:${code}`)}
        </S.TitleLabel>
      </S.FlexColumn>
    </S.Root>
  );
};
